Vue.component('vq-datepicker', {
	delimiters: [ '[[', ']]' ],
	inject: [ '$validator' ],
	mixins: [ eventHubMixin, baseMixin ],
	components: {
		vuejsDatepicker
	},
	props: {
		label: String,
		labelClasses: String,
		model: Object,
		name: String,
		readOnly: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'text'
		},
		optional: {
			type: Boolean,
			default: false
		},
		validate: {
			type: String,
			default: 'required'
		},
		validateName: String,
		validation: {
			type: Boolean,
			default: true
		},
		tooltip: String,
		placeholder: String
	},
	data: function() {
		return {
			tooltipOpen: false,
            language: gettext('fr') == 'fr' ? vdp_translation_fr.js : vdp_translation_en.js
		};
	},
	computed: {
		sync_model: {
			get() {
				return this.model.value;
			},
			set(val) {
				// if (this.type === 'date') {
				// 	val = new Date(val);
				// 	val = val.toISOString().substring(0, 10);
				// }
				val !== '' && (val = moment(val).format('YYYY-MM-DD'));
				this.$emit('update:model', { value: val });
			}
		},
		sync_validate() {
			if (this.optional && this.validate == 'required') {
				return '';
			} else if (!this.optional && this.validate != 'required') {
				return 'required|' + this.validate;
			} else {
				return this.validate;
			}
		},
		sync_validateName() {
			if (!this.validateName && this.label) {
				return this.label;
			} else {
				return this.validateName;
			}
		}
	},
	watch: {
		model: {
			immediate: true,
			handler() {
				if (!this.model.hasOwnProperty('value') || this.model.value == null) {
					this.sync_model = '';
				}

				// if (this.errors.has(this.name) || (this.fields.hasOwnProperty(this.name) && this.fields[this.name].dirty && this.model.value != '')) {
				if (this.errors.has(this.name)) {
					this.$validator.validate(this.name);
				}
			}
		}
	},
	methods: {
		customFormatter(date) {
			return moment(date).format('MMMM Do YYYY');
		},
		classesValidation() {
			if (this.validation && !this.readOnly) {
				return {
					'is-valid':
						!this.errors.has(this.name) &&
						this.fields[this.name] &&
						this.fields[this.name].valid &&
						this.model.value != '' &&
						this.fields[this.name].validated,
					'is-error': this.errors.has(this.name)
				};
			}
		},
		reset() {
			this.sync_model = '';
			this.$refs.field.focus();
		},
		validateField() {
			this.$validator.validate(this.name);
		}
	},
	mounted() {
		if (![ undefined, null, '' ].includes(this.model.value)) {
			this.$validator.validate(this.name);
		}
		this.eventHub.$on(`document:click`, () => {
			this.tooltipOpen = false;
		});
	},
	template: `<div class="form-control" :class="[classesValidation(), {'has-validation': validation, 'is-read-only': readOnly}]">
    <label class="label pb-5" :class="labelClasses" :for="name" v-if="label">
        [[label]]
        <div class="tooltip" v-if="tooltip">
            <i class="block icon icon-question-mark" :class="{'hover': tooltipOpen }"
                @click.stop.prevent="tooltipOpen = !tooltipOpen"></i>
            <div class="inner">
                [[tooltip]]
            </div>
        </div>
    </label>
    <div class="wrapper" :class="{'is-resetable': !readOnly, 'is-empty' : model.value == ''}">
        <span class="is-optional" v-if="optional">optionnel</span>
        <vuejs-datepicker ref="field" input-class="input" :name="name" v-model="sync_model" :id="name" v-validate="sync_validate" :data-vv-as="sync_validateName" @selected="validateField()" format="d MMMM yyyy" :language="language" :initial-view="name.includes('starting') ? 'day' : 'year'"></vuejs-datepicker>
        <button type="button" class="reset" @click="reset" v-if="!readOnly && model.value != ''" tabindex="-1"></button>
    </div>
</div>
`
});
